import React, { useState } from "react"

import { EVENTS, useEventBus } from "@/inspection-events"

import { TimeSeriesLineChart } from "@/components/charts/TimeSeriesLineChart"

type Props = Omit<React.ComponentProps<typeof TimeSeriesLineChart>, "playheadX">

// Wraps the generic time-series chart with a live playhead driven by audio
// playback (AUDIO_TIME on the deep-dive event bus). Use in audio deep dives so
// the plot tracks the player; keeps TimeSeriesLineChart itself domain-free.
export function PlayheadTimeSeriesLineChart(props: Props): React.ReactElement {
  const [playheadX, setPlayheadX] = useState<number | null>(null)
  useEventBus(
    EVENTS.AUDIO_TIME,
    (payload) => {
      setPlayheadX(payload.time)
    },
    [],
  )
  return <TimeSeriesLineChart {...props} playheadX={playheadX} />
}
